import client from './client';

export interface LeaveBalance {
  id: number;
  company_id: number;
  user_id: number;
  account_label: string;
  leave_type: string;
  leave_type_label: string;
  balance: number;
  pending_days: number;
  estimated_balance: number;
  expiry_date?: string | null;
}

export interface LeaveRequest {
  id: number;
  company_id: number;
  user_id: number;
  employee_id?: number | null;
  leave_type: string;
  leave_type_label: string;
  leave_balance_id?: number | null;
  account_label?: string | null;
  start_date: string;
  end_date: string;
  days_count: number;
  status: 'pending' | 'approved' | 'rejected' | 'cancelled';
  status_label: string;
  comment?: string | null;
  rh_comment?: string | null;
  reviewed_by?: number | null;
  reviewed_at?: string | null;
  created_at: string;
  user_name?: string | null;
  user_email?: string | null;
  employee_name?: string | null;
}

export const leaveApi = {
  listMyBalances: () =>
    client.get<{ success: boolean; data: { balances: LeaveBalance[] } }>('/leave/balances/me'),

  listMyRequests: () =>
    client.get<{ success: boolean; data: { requests: LeaveRequest[] } }>('/leave/requests/me'),

  createRequest: (data: {
    leave_type: string;
    start_date: string;
    end_date: string;
    leave_balance_id?: number;
    comment?: string;
  }) => client.post<{ success: boolean; data: LeaveRequest; message?: string }>('/leave/requests', data),

  cancelRequest: (id: number) =>
    client.post<{ success: boolean; data: LeaveRequest; message?: string }>(`/leave/requests/${id}/cancel`),

  listRequests: (params?: { status?: string; page?: number; per_page?: number }) =>
    client.get<{
      success: boolean;
      data: {
        requests: LeaveRequest[];
        total?: number;
        pending_count?: number;
      };
    }>('/leave/requests', { params }),

  reviewRequest: (id: number, data: { action: 'approve' | 'reject'; rh_comment?: string }) =>
    client.post<{ success: boolean; data: LeaveRequest; message?: string }>(
      `/leave/requests/${id}/review`,
      data,
    ),

  meta: () =>
    client.get<{ success: boolean; data: { leave_types: { value: string; label: string }[] } }>(
      '/leave/meta',
    ),
};
